var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasPath("/it/asset"))?_c('asset-index',{staticStyle:{"margin-bottom":"10px"}}):_vm._e(),(_vm.hasPath("/it/contract"))?_c('contract-index',{staticStyle:{"margin-bottom":"10px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }